<template>
  <div class="topup">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">{{ module.Name }}</div>
      </q-card-section>
      <q-separator />
        <q-card-section class="card-content">
          <div class="referrer" v-if="user.referrer">You've been referred by <strong>{{ user.referrer.ReferralCode }}</strong>. If you want to change, Just click Input Referrer.</div>
          <div class="change-referrer" @click="disableReferrer = false">Input Referrer</div>
          <q-input
            square
            outlined
            label="CODE"
            type="email"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.code"
            @update:model-value="(e) => fields.code = e"
            @blur="v$.fields.code.$touch()"
            :error="v$.fields.code.$error"
            error-message="Code is required."
          />
          <q-input
            square
            outlined
            type="email"
            label="PIN"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.pin"
            @update:model-value="(e) => fields.pin = e"
            @blur="v$.fields.pin.$touch()"
            :error="v$.fields.pin.$error"
            error-message="Pin is required."
          />
          <!-- <q-input
            square
            outlined
            label="Referrer"
            color="white"
            label-color="white"
            outline-color="white"
            :input-style="{ color: 'white' }"
            :model-value="fields.referrer"
            @update:model-value="(e) => fields.referrer = e"
            :readonly="disableReferrer"
          /> -->
        <q-btn class="topup-btn" label="Submit" @click="submit"/>
      </q-card-section>
    </q-card>
  </div>
</template>
  <script>
  import { mapActions, mapGetters } from 'vuex';
  import { required } from "vuelidate/lib/validators";
  import { useVuelidate } from '@vuelidate/core'
  
  export default {
    name: 'TopUp',
    props: {
      module: {
        require: true,
        type: Object
      }
    },
    setup () {
      return { v$: useVuelidate() }
    },
    validations () {
      return {
        fields: {
          code: {
            required
          },
          pin: {
            required
          }
        }
      }
    },
    data () {
      return {
        fields: {
          code: null,
          pin: null,
          referrer: null
        },
        disableReferrer: true
      }
    },
    methods: {
      ...mapActions({
        topup: 'user/topup'
      }),
      async submit () {
        this.v$.fields.$touch()

        if (this.v$.fields.$invalid) {
          return
        }

        this.$q.loading.show();
        
        await this.recaptchaLoad('topup')
  
        await this.topup(this.fields)
          .then(async () => {
            this.recaptchaLoad('topup')

            this.resetFields()

            this.$q.notify({
              position: 'top-right',
              message: 'Topup Success!',
              type: 'positive'
            })
  
            this.$q.loading.hide()
          })
          .catch((error) => {
            this.$q.notify({
              position: 'top-right',
              message: error.response.data.message,
              type: 'negative'
            })
  
            this.$q.loading.hide();
          })
      },
      resetFields() {
        this.v$.fields.$reset()
        this.fields = {
          code: null,
          pin: null,
          referrer: this.user.referrer ? this.user.referrer.ReferralCode : null
        }
      }
    },
    mounted () {
      if (this.user.referrer) this.fields.referrer = this.user.referrer.ReferralCode
    },
    computed: {
      ...mapGetters({
        user: 'user/getUser'
      })
    }
  }
</script>
<style lang="scss">
.topup {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      gap: 16px;
    }

    .referrer {
      color: white;
    }

    .change-referrer {
      color: blue;
      cursor: pointer;

    }

    .q-input {
      color: white;
    }

    .q-field__control:before {
      border-color: white;
    }
    
    .topup-btn {
      background-color: #FFC108;
    }
  }

  .q-layout__section--marginal {
    background-color: $background;
  }
}
</style>